import { styled } from '@linaria/react';
import ReactSlider from 'react-slider';

import { Text } from '~components/Typography';

export const StyledSlider = styled(ReactSlider)`
	width: 100%;
	height: 1.6rem;
	align-items: center;
	justify-content: center;
`;

export const StyledTrack = styled.div<{ index: number }>`
	top: 0.6rem;
	height: 0.4rem;
	border-radius: var(--radius-s);
	background: ${(props) =>
		props.index === 1 ? 'var(--color-white-solid)' : 'var(--color-white-m)'};
`;

export const ThumbWrapper = styled.div`
	top: -0.4rem;
	width: 1.6rem;
	height: 2.4rem;
	padding-top: 0.4rem;
	padding-bottom: 0.4rem;
`;

export const StyledThumb = styled.div`
	width: 100%;
	height: 100%;
	border: 2px solid var(--color-white-solid);
	border-radius: var(--radius-xxs);
	background-color: var(--color-black-solid);
	box-shadow: 0 2px 18px var(--color-white-l);
	text-indent: 100%;
	white-space: nowrap;
`;

export const SliderWrapper = styled.div`
	display: flex;
	align-items: center;
	padding: 1.2rem;
	border-radius: var(--radius-xs);
	background: var(--color-white-xxs);
`;

export const Label = styled(Text)`
	width: 3.5rem;
`;
